import { render, staticRenderFns } from "./ViolationDataTable.vue?vue&type=template&id=c55f0744"
import script from "./ViolationDataTable.vue?vue&type=script&lang=js"
export * from "./ViolationDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports